import Vue from 'vue'

Vue.directive('scroller', {
  bind: function (el, _, vnode) {
    vnode.context.manualScroll = false
  },
  componentUpdated: function (el, _, vnode) {
    if (el.scrollHeight - el.scrollTop >= el.clientHeight) {
      // scroll to bottom
      if (!vnode.context.manualScroll) {
        el.scrollTop = el.scrollHeight - el.clientHeight // triggers scroll event
      }
    }
  },
  inserted: function (el, _, vnode) {
    el.scrollTop = el.scrollHeight - el.clientHeight
    el.addEventListener('scroll', function () {
      vnode.context.manualScroll = (el.scrollTop < el.scrollHeight - el.clientHeight - 50) // this number is a tolerance
    })
  }
})
